function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import * as Likes from './likes';
import * as AdminTools from './admin-tools';
export var API = function API() {
  _classCallCheck(this, API);
};
API.Likes = Likes;
API.AdminTools = AdminTools;